// eslint-disable-next-line @atlaskit/design-system/use-spotlight-package
import { SpotlightCard as AkSpotlightCard } from '@atlaskit/onboarding';
import type { SpotlightCardProps } from '@atlaskit/onboarding/types';

import type {
	ChoreographedComponentProps,
	ChoreographerMessageTypes,
	ChoreographerUtilities,
} from '../../types';
import { wrapComponentForChoreographer } from '../utils';

export const SpotlightCard: {
	({
		shouldBeChoreographed,
		withChoreographedRender,
		...props
	}: SpotlightCardProps &
		ChoreographerUtilities &
		Partial<ChoreographedComponentProps> & {
			messageType?: ChoreographerMessageTypes;
		}): React.JSX.Element;
	displayName: string;
} = wrapComponentForChoreographer<SpotlightCardProps>(AkSpotlightCard);
